import { render, staticRenderFns } from "./PayInvoice_submit.vue?vue&type=template&id=a5885f18&scoped=true"
import script from "./PayInvoice_submit.vue?vue&type=script&lang=js"
export * from "./PayInvoice_submit.vue?vue&type=script&lang=js"
import style0 from "./PayInvoice_submit.vue?vue&type=style&index=0&id=a5885f18&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a5885f18",
  null
  
)

export default component.exports